import React from "react";
import styled from "styled-components";
import { Toggle } from "ui";

export function SwitchField({
  label = "Switch to Notification Post",
  labelIsAfter = false,
  defaultChecked = false,
  onChange = () => {},
  disabled = false,
  checked = undefined,
  compact = false,
  className,
}) {
  const isControlled = checked !== undefined;
  const toggleProps = {};
  if (isControlled) {
    toggleProps.checked = checked;
  } else {
    toggleProps.defaultChecked = defaultChecked;
  }
  return (
    <SwitchContainer className={className} $compact={compact}>
      {!labelIsAfter && (
        <SwitchDescription $compact={compact}>{label}</SwitchDescription>
      )}
      <Toggle
        {...toggleProps}
        icons={{
          unchecked: null,
        }}
        className={`active-purple ${compact ? "compact-toggle" : ""}`}
        onChange={onChange}
        disabled={disabled}
      />
      {labelIsAfter && (
        <SwitchDescription after $compact={compact}>
          {label}
        </SwitchDescription>
      )}
    </SwitchContainer>
  );
}
const SwitchContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${(props) => (props.$compact ? "8px" : 0)};
`;

const SwitchDescription = styled.div`
  margin-right: ${(props) => (props.$compact || props.after ? 0 : "10px")};
  margin-left: ${(props) => (props.$compact || !props.after ? 0 : "10px")};
  color: ${(props) => (props.$compact ? "#333333" : "inherit")};
  font-family: ${(props) => (props.$compact ? "Inter, sans-serif" : "inherit")};
  font-size: ${(props) => (props.$compact ? "14px" : "12px")};
  font-weight: 500;
  line-height: ${(props) => (props.$compact ? "20px" : "inherit")};
`;
